module.exports = __webpack_public_path__ + "img/rebuild_liao_pc1.68492be4.jpg";